import script from "./right-top.vue?vue&type=script&setup=true&lang=ts"
export * from "./right-top.vue?vue&type=script&setup=true&lang=ts"

import "./right-top.vue?vue&type=style&index=0&id=0d828799&scoped=true&lang=stylus"

import exportComponent from "/Users/yangwenqi/Desktop/蓝豚/web/pc-customer-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d828799"]])

export default __exports__